import { Injectable } from "@angular/core";
import "rxjs/Rx";
import { Subject } from "rxjs/Subject";
import { Router, NavigationEnd } from "@angular/router";
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { SideMenuItem } from "@common/side-menu-list-item";
import {
  PATH_ABM,
  PATH_ADMINISTRACION,
  PATH_AGENDA,
  PATH_AGRIS_HOME,
  PATH_BANNERS,
  PATH_CLIENTES,
  PATH_CLIENTES_ACOPIO,
  PATH_COMUNICADOS,
  PATH_CREDITOS,
  PATH_DASHBOARD,
  PATH_DOLAR,
  PATH_FINANCIERA,
  PATH_GRANOS_BASE_NEW,
  PATH_MERCADO_AGD,
  PATH_NEGOCIOS,
  PATH_NEGOCIOS_NEW,
  PATH_PIPELINE,
  PATH_PIZARRA,
  PATH_PRECIOS,
  PATH_TABLERO,
} from '../navigation/navigation.module';
import { ActividadService } from "@services/actividad-service";
import { PreciosService } from "@services/precios-service";
import { PERM_ACCIONES_ID, PermisosService } from "@services/permisos-service";
import { ColaboradoresService } from "@services/colaboradores-service";

@Injectable()
export class NavigationService {
  private isBackBtnReadyFlag: boolean = false;
  private previousUrl: string = "";

  public currentURL = new BehaviorSubject<string>("");
  public $currentURL = this.currentURL.asObservable();

  // Observable string sources
  private emitToggleNav = new Subject<any>();
  // Observable string streams
  toggleNav$ = this.emitToggleNav.asObservable();

  // lo mantenemos en una variable y como publico pues se usa en otras partes de codigo para evitar hacer comparaciones a un string
  public indicadoresMainName = "Indicadores";
  public homeInicioMainName = "Inicio";

  // lista de items del menu lateral
  private homeInicioItem: SideMenuItem = {
    id: "btnNavHome",
    MainName: this.homeInicioMainName,
    MainIconName: "home",
    MainIconSVGName: "",
    MainURL: ["home/inicio"],
    IsNewAngularURL: true,
    open: false,
    bubble: false,
    allowed: true,
    jdeAllowed: true,
    Subtree: [],
  };

  // aqui registramos la lista de items de menu
  private indicadoresItem: SideMenuItem = {
    id: "btnNavIndicadores",
    MainName: this.indicadoresMainName,
    MainIconName: "fact_check",
    MainIconSVGName: "",
    MainURL: [
      "indicadores/dash-board",
      "indicadores/evolucion-plan-comercial",
      "indicadores/gestionar-plan-comercial",
      "indicadores/radar",
    ],
    IsNewAngularURL: true,
    open: false,
    bubble: false,
    allowed: false,
    jdeAllowed: true,
    Subtree: [
      {
        id: "btnNavIndicadoresDashboard",
        Name: "Tablero",
        IconName: "bar_chart",
        SVGIconName: "",
        URL: "indicadores/dash-board",
        bubble: false,
        allowed: true,
      },
      {
        id: "btnNavIndicadoresAvances",
        Name: "Avances",
        IconName: "assessment",
        SVGIconName: "",
        URL: "indicadores/evolucion-plan-comercial",
        bubble: false,
        allowed: true,
      },
      {
        id: "btnNavIndicadoresPlanesComerciales",
        Name: "Planes Comerciales",
        IconName: "ads_click",
        SVGIconName: "",
        URL: "indicadores/gestionar-plan-comercial",
        bubble: false,
        allowed: true,
      },
       {
        id: "btnNavIndicadoresRadar",
        Name: "Radar",
        IconName: "radar",
        SVGIconName: "",
        URL: "indicadores/radar",
        bubble: false,
        allowed: true,
      },
    ],
  };

  private negociosItem: SideMenuItem = {
    id: "btnGranos",
    MainName: "Granos",
    MainIconName: "",
    MainIconSVGName: "soja",
    MainURL: [`${PATH_GRANOS_BASE_NEW}/${PATH_NEGOCIOS_NEW}`, `${PATH_GRANOS_BASE_NEW}/${PATH_TABLERO}`],
    IsNewAngularURL: true,
    open: false,
    bubble: false,
    allowed: true,
    jdeAllowed: true,
    Subtree: [
      {
        id: "btnGranosNegocios",
        Name: "Negocios",
        IconName: "reorder",
        SVGIconName: "",
        URL: `${PATH_GRANOS_BASE_NEW}/${PATH_NEGOCIOS_NEW}`,
        bubble: false,
        allowed: true,
      },
      // {Name: 'Pipeline', IconName: 'view_week', SVGIconName: '', URL: PATH_PIPELINE, bubble: false, allowed: true},
      {
        id: "btnGranosDashboard",
        Name: "Dashboard",
        IconName: "donut_large",
        SVGIconName: "",
        URL: `${PATH_GRANOS_BASE_NEW}/${PATH_TABLERO}`,
        bubble: false,
        allowed: true,
      },
    ],
  };

  private preciosItem: SideMenuItem = {
    id: "btnVisorDePrecios",
    MainName: "Visor de Precios",
    MainIconName: "",
    MainIconSVGName: "precios",
    MainURL: [`${PATH_PRECIOS}/${PATH_MERCADO_AGD}`, `${PATH_PRECIOS}/${PATH_PIZARRA}`, `${PATH_PRECIOS}/${PATH_DOLAR}`],
    IsNewAngularURL: true,
    open: false,
    bubble: false,
    allowed: false,
    jdeAllowed: true,
    Subtree: [
      {
        id: "btnVisorDePreciosMercadoAGD",
        Name: "Mercado AGD",
        IconName: "",
        SVGIconName: "precio-agd",
        URL: `${PATH_PRECIOS}/${PATH_MERCADO_AGD}`,
        bubble: false,
        allowed: false,
      },
      {
        id: "btnVisorDePreciosPizzaras",
        Name: "Pizarras",
        IconName: "monetization_on",
        SVGIconName: "",
        URL: `${PATH_PRECIOS}/${PATH_PIZARRA}`,
        bubble: false,
        allowed: false,
        extraIconClasses: "material-icons material-icons-outlined",
      },
      {
        id: "btnVisorDePreciosDolar",
        Name: "Dolar",
        IconName: "account_balance",
        SVGIconName: "",
        URL: `${PATH_PRECIOS}/${PATH_DOLAR}`,
        bubble: false,
        allowed: false,
      },
    ],
  };

  private agrisItem: SideMenuItem = {
    id: "btnAgris",
    MainName: "Agris",
    MainIconName: "",
    MainIconSVGName: "agris",
    MainURL: [PATH_AGRIS_HOME],
    IsNewAngularURL: true,
    open: false,
    bubble: false,
    allowed: false,
    jdeAllowed: true,
    Subtree: [],
  };

  private safCreditosItem: SideMenuItem = {
    id: "btnCreditos",
    MainName: "Créditos",
    MainIconName: "",
    MainIconSVGName: "creditos",
    MainURL: [PATH_CREDITOS],
    IsNewAngularURL: true,
    open: false,
    bubble: false,
    allowed: false,
    jdeAllowed: true,
    Subtree: [],
  };

  private logisticaItem: SideMenuItem = {
    id: "btnLogistica",
    MainName: "Logística",
    MainIconName: "local_shipping",
    MainIconSVGName: "",
    MainURL: ["logistica"],
    IsNewAngularURL: true,
    open: false,
    bubble: false,
    allowed: false,
    jdeAllowed: true,
    Subtree: [],
  };

  private administracionItem: SideMenuItem = {
    id: "btnAdministracion",
    MainName: "Administracion",
    MainIconName: "request_quote",
    MainIconSVGName: "",
    MainURL: [PATH_ADMINISTRACION],
    IsNewAngularURL: false,
    open: false,
    bubble: false,
    allowed: false,
    jdeAllowed: true,
    Subtree: [],
  };

  private clientesItem: SideMenuItem = {
    id: CLIENT_TYPE.EVOLUTIVO_CLIENTES_TOTALES.toString(),
    MainName: "Clientes",
    MainIconName: "account_box",
    MainIconSVGName: "",
    MainURL: [PATH_CLIENTES, PATH_CLIENTES_ACOPIO],
    IsNewAngularURL: true,
    open: false,
    bubble: false,
    allowed: true,
    jdeAllowed: true,
    Subtree: [
        {
        id: CLIENT_TYPE.EVOLUTIVO_CLIENTES_TOTALES.toString(),
        Name: "Empresas",
        IconName: "domain",
        SVGIconName: "",
        URL: `${PATH_CLIENTES}/${PATH_CLIENTES_ACOPIO}`,
        bubble: false,
        allowed: true,
      },
        {
        id: CLIENT_TYPE.EVOLUTIVO_CLIENTES_CONTACTO.toString(),
        Name: "Contactos",
        IconName: "badge",
        SVGIconName: "",
        URL: `${PATH_CLIENTES}/${PATH_CLIENTES_ACOPIO}`,
        bubble: false,
        allowed: true,
      },
        {
        id: CLIENT_TYPE.EVOLUTIVO_CLIENTES_PROSPECTO.toString(),
        Name: "Prospectos",
        IconName: "",
        SVGIconName: "icono_prospecto",
        URL: `${PATH_CLIENTES}/${PATH_CLIENTES_ACOPIO}`,
        bubble: false,
        allowed: true,
      },
         {
        id: CLIENT_TYPE.EVOLUTIVO_CLIENTES_USUARIO.toString(),
        Name: "Usuarios",
        IconName: "person",
        SVGIconName: "",
        URL: `${PATH_CLIENTES}/${PATH_CLIENTES_ACOPIO}`,
        bubble: false,
        allowed: true,
      },
    ],
  };

  private agendaItem: SideMenuItem = {
    id: "btnAgenda",
    MainName: "Agenda",
    MainIconName: "calendar_today",
    MainIconSVGName: "",
    MainURL: [PATH_AGENDA],
    IsNewAngularURL: false,
    open: false,
    bubble: false,
    allowed: false,
    jdeAllowed: true,
    Subtree: [],
  };

  private comunicadosItem: SideMenuItem = {
    id: "btnComunicados",
    MainName: "Comunicados",
    MainIconName: "campaign",
    MainIconSVGName: "",
    MainURL: [PATH_COMUNICADOS],
    IsNewAngularURL: false,
    open: false,
    bubble: false,
    allowed: false,
    jdeAllowed: true,
    Subtree: [],
  };

  public mainMenuItems: SideMenuItem[] = [];

  public abmItem: SideMenuItem = {
    id: "btnABM",
    MainName: "ABM",
    MainIconName: "assignment",
    MainIconSVGName: "",
    MainURL: [PATH_ABM],
    IsNewAngularURL: false,
    open: false,
    bubble: false,
    allowed: false,
    jdeAllowed: true,
    Subtree: [],
  };

  public logoutItem: SideMenuItem = {
    id: "btnLogout",
    MainName: "Cerrar Sesión",
    MainIconName: "power_settings_new",
    MainIconSVGName: "",
    MainURL: [],
    IsNewAngularURL: false,
    open: false,
    bubble: false,
    allowed: true,
    jdeAllowed: true,
    Subtree: [],
  };

  private bannersItem: SideMenuItem = {
    id: 'btnMktCloud',
    MainName: 'MKT Cloud',
    MainIconName: 'flip_to_front',
    MainIconSVGName: '',
    MainURL: [PATH_BANNERS],
    IsNewAngularURL: true,
    open: false,
    bubble: false,
    allowed: true,
    jdeAllowed: true,
    Subtree: [],
  };

  constructor(
    private router: Router,
    private actividadService: ActividadService,
    private preciosService: PreciosService,
    private permisosService: PermisosService,
    private colaboradoresService: ColaboradoresService
  ) {
    this.buildMainMenuArray();
    this.checkSideMenuBubbles();
    this.currentURL.next(this.router.url.substring(1));
    this.router.events
      .filter((event) => event instanceof NavigationEnd)
      .subscribe((e: any) => {
        if (this.previousUrl.length) {
          this.isBackBtnReadyFlag = true;
        }
        this.previousUrl = e.url;
        this.currentURL.next(e.url);
      });
  }

  toggleNav(change: any) {
    this.emitToggleNav.next(change);
    this.collapseAllMenuOptions(null);
  }

  isBackBtnReady() {
    // This will be true when we've visited at least 2 pages of
    // the site in our current browser tab
    return this.isBackBtnReadyFlag;
  }

  collapseAllMenuOptions(exclude: SideMenuItem) {
    this.mainMenuItems.forEach((item) => {
      if (!(exclude && item === exclude)) {
        item.open = false;
      }
    });
  }

  checkSideMenuBubbles() {
    this.preciosService.checkPrecioFlag$.subscribe((x) => {
      this.preciosItem.Subtree[0].bubble = x;
      this.hasBubble(this.preciosItem);
      this.buildMainMenuArray();
    });

    this.preciosService.checkPrecioPizarraFlag$.subscribe((x) => {
      this.preciosItem.Subtree[1].bubble = x;
      this.hasBubble(this.preciosItem);
      this.buildMainMenuArray();
    });

    this.preciosService.checkPrecioFinancieraFlag$.subscribe((x) => {
      this.preciosItem.Subtree[2].bubble = x;
      this.hasBubble(this.preciosItem);
      this.buildMainMenuArray();
    });

    this.actividadService.checkComunicacionFlag$.subscribe((x) => {
      this.comunicadosItem.bubble = x;
      this.buildMainMenuArray();
    });
  }

  hasBubble(item: SideMenuItem) {
    item.bubble = item.Subtree.some((x) => x.bubble);
  }

  checkPermisos() {
    this.preciosItem.Subtree[0].allowed =
      this.permisosService.permisoAutorizado(PERM_ACCIONES_ID.P_Precios);
    this.preciosItem.Subtree[1].allowed =
      this.permisosService.permisoAutorizado(PERM_ACCIONES_ID.P_PreciosPizarra);
    this.preciosItem.Subtree[2].allowed =
      this.permisosService.permisoAutorizado(PERM_ACCIONES_ID.P_Financiera);
    this.preciosItem.allowed = this.preciosItem.Subtree.some((x) => x.allowed);
    this.abmItem.allowed = this.permisosService.permisoAutorizado(
      PERM_ACCIONES_ID.P_ABM
    );
    this.agendaItem.allowed = this.permisosService.permisoAutorizado(
      PERM_ACCIONES_ID.P_Actividad
    );
    this.administracionItem.allowed = this.permisosService.permisoAutorizado(
      PERM_ACCIONES_ID.P_Administracion
    );
    this.comunicadosItem.allowed = this.permisosService.permisoAutorizado(
      PERM_ACCIONES_ID.P_Actividad_Comunicados
    );
    this.agrisItem.allowed = this.permisosService.permisoAutorizado(
      PERM_ACCIONES_ID.P_Agris
    );
    this.safCreditosItem.allowed = this.permisosService.permisoAutorizado(
      PERM_ACCIONES_ID.P_Saf_Creditos
    );
    this.indicadoresItem.Subtree[0].allowed =
      this.permisosService.permisoAutorizado(
        PERM_ACCIONES_ID.P_Indicadores_Dashboard
      );
    this.indicadoresItem.Subtree[1].allowed =
      this.permisosService.permisoAutorizado(
        PERM_ACCIONES_ID.P_Indicadores_Avances
      );
    this.indicadoresItem.Subtree[2].allowed =
      this.permisosService.permisoAutorizado(PERM_ACCIONES_ID.P_Indicadores);
      this.indicadoresItem.Subtree[3].allowed =
      this.permisosService.permisoAutorizado(PERM_ACCIONES_ID.P_Indicadores_evolutivo_radar);
    this.indicadoresItem.allowed = this.indicadoresItem.Subtree.some(
      (x) => x.allowed
    );
    this.logisticaItem.allowed = this.permisosService.permisoAutorizado(
      PERM_ACCIONES_ID.P_Logistica
    );
    this.bannersItem.allowed = this.permisosService.permisoAutorizado(
      PERM_ACCIONES_ID.P_BANNERS
    );

    this.colaboradoresService.getUserJDEAccess().subscribe((x) => {
      if (x !== null && x !== undefined) {
        this.agrisItem.jdeAllowed = x.length > 0;
      }
    });

    this.buildMainMenuArray();
  }

  buildMainMenuArray() {
    // manejamos el array de esta manera dado que necesitamos modificar datos de los mismos

    // antes de construir el array vamos a limitar los modulos que no esten permitidos por no ser responsivos
    // if (!this.responsiveService._isDesktop) {
    //    // EJ: this.administracionItem.allowed = false;
    // }

    this.mainMenuItems = [
      this.homeInicioItem,
      this.indicadoresItem,
      this.clientesItem,
      this.negociosItem,
      this.preciosItem,
      this.agrisItem,
      this.logisticaItem,
      this.safCreditosItem,
      this.administracionItem,
      this.agendaItem,
      this.comunicadosItem,
      this.bannersItem
    ];
  }

  public get availableMenuOptions() {
    return [
      this.homeInicioItem,
      this.indicadoresItem,
      this.clientesItem,
      this.negociosItem,
      this.preciosItem,
      this.agrisItem,
      this.safCreditosItem,
      this.administracionItem,
      this.agendaItem,
      this.comunicadosItem,
      this.bannersItem,
      this.abmItem,
    ].filter((x) => x.allowed);
  }
}
 export enum CLIENT_TYPE {
  EVOLUTIVO_CLIENTES_TOTALES = 7,
  EVOLUTIVO_CLIENTES_ANILLADO = 8,
  EVOLUTIVO_CLIENTES_PROSPECTO = 9,
  EVOLUTIVO_CLIENTES_CONTACTO = 10,
  EVOLUTIVO_CLIENTES_USUARIO = 11,
 }


// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/services/navigation-service.ts